export default __webpack_public_path__ + "locales/ja-JP/Files.json?hash=6a9e738eeff0dde44fc8750c5a566085";